import type { FormEvent } from "react";
import { RequiredMark } from "./ui-kit";

// Shared by the Sprints tab (src/sprints-page.tsx) and the Backlog view's
// Jira-style "+ Create sprint" control (src/task-workspace.tsx) -- both post
// the same fields to POST /api/sprints, so the form markup lives in one
// place rather than being duplicated across the two pages.
export function SprintCreateForm({
  busy,
  onSubmit,
}: {
  busy: boolean;
  onSubmit: (event: FormEvent<HTMLFormElement>) => void;
}) {
  return (
    <form className="sprint-create-form" onSubmit={onSubmit}>
      <label><span>Sprint name<RequiredMark /></span><input autoFocus name="name" placeholder="Sprint 12" required /></label>
      <label>Sprint goal<input name="goal" placeholder="What outcome should this sprint achieve?" /></label>
      <label>Starts<input name="startsOn" type="date" /></label>
      <label>Ends<input name="endsOn" type="date" /></label>
      <button className="button primary" disabled={busy} type="submit">{busy ? "Creating…" : "Create sprint"}</button>
    </form>
  );
}
